<app-text-box [control]="searchTxtCtrl"
              [placeholder]="placeholder"
              [iconCallback]="iconCallback"
              #textBox
              [inputCallback]="inputCallback"
              [iconName]="iconName"></app-text-box>
